export default __webpack_public_path__ + "static/media/Img_NewFindYourJoy_LandingPage_03.104e7bad.png";